import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRemoveCompanyPayload {
    data: {
        ids: string[]
    }
}

export interface IRemoveCompanyState {
    status: string
    data: any
    errors: any
}

const initialState: IRemoveCompanyState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const removeCompany = createSlice({
    name: 'matchList/remove-company',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IRemoveCompanyPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const removeCompanyActions = removeCompany.actions
export default removeCompany.reducer
